// extracted by mini-css-extract-plugin
export var active = "styles-module--active--50bd9";
export var cardWrapper = "styles-module--cardWrapper--7743a";
export var icon = "styles-module--icon--aec52";
export var sidebarTitle = "styles-module--sidebarTitle--e815b";
export var title = "styles-module--title--b6f47";
export var wrapper = "styles-module--wrapper--f178e";